import React, { useEffect, useState } from "react";
import TaskInformation from "../TaskInformation";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import ValidationButton from "../ValidationButton";
import PreviewButton from "../PreviewButton";
import { useDispatch, useSelector } from "react-redux";
import { completeTask, getTask } from "../../../store/action/taskAction";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImagesTab from "../../sinistreSection/photoSection";
import PropTypes from "prop-types";
import { BsUpload } from 'react-icons/bs';
import { addMetaDataToFile, uploadFile, deleteFileImage, getAllFileForClaim } from '../../../store/action/fileManagement';
import { TailSpin } from "react-loader-spinner";
import { useNavigate, useParams } from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";
import PreviewPDF from '../PreviewPDF';
import { toast } from "react-toastify";

const THEME_MAIN_COLOR = 'rgba(60, 101, 86, 1)'; // theme green
const THEME_ACCENT_BG = 'rgba(60, 101, 86, 0.15)'; // theme green translucent
const THEME_BORDER = '#3C6556';

const commonButtonStyle = {
    fontFamily: 'Poppins',
    fontSize: '10.76px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    opacity: '0px',
    borderRadius: '5.38px',
};
const annulerStyle = {
    ...commonButtonStyle,
    width: 'fit-content',
    height: '36px',
    backgroundColor: 'rgba(229, 234, 238, 1)',
    color: 'rgb(225, 31, 31)',
    marginRight: '20px'
};
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    paper: {
        borderRadius: "11px",
        width: "100%",
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
    },
    paper1: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '11px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
        width: "100%",
        minHeight: '374px',
        margin: '0 auto',
        padding: 0,
        boxSizing: "border-box",
    },
    leftSection: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 0',
        flexDirection: 'column'
    },
    uploadRectangle: {
        width: '100%',
        height: '600px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        opacity: 0.8,
        backgroundColor: 'rgba(243, 246, 249, 1);',
    },
    uploadTextPrimary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '24px',
        color: THEME_MAIN_COLOR,
        marginTop: '10px',
    },
    uploadTextSecondary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '23px',
        textAlign: 'center',
        color: 'rgba(128, 128, 143, 1)',
        marginTop: '5px',
    },
    hiddenInput: {
        display: 'none',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    }
}));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div style={{ width: "100%", background: 'rgba(255, 255, 255, 1)' }}>
                    {children}
                </div>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

// Custom tab color style for showing which one is selected
const getTabSx = (isSelected) => ({
    textTransform: 'none',
    height: 50,
    fontFamily: 'Poppins',
    fontSize: '13px',
    fontWeight: isSelected ? 700 : 600,
    lineHeight: '19.5px',
    textAlign: 'center',
    marginRight: '5px',
    borderRadius: '8px 8px 0 0',
    transition: 'background 0.15s, color 0.15s',
    background: isSelected ? THEME_ACCENT_BG : 'rgba(255, 255, 255, 0.35)',
    color: isSelected ? THEME_MAIN_COLOR : 'rgba(63, 66, 84, 0.64)',
    borderBottom: isSelected ? `1px solid ${THEME_BORDER}` : '1px solid transparent',
    // Remove blue focus ring and ripple for selected
    "&.Mui-selected": {
        color: THEME_MAIN_COLOR,
        background: THEME_ACCENT_BG
    },
    "&.Mui-focusVisible": {
        background: THEME_ACCENT_BG,
        outline: `1px solid ${THEME_BORDER}`,
        outlineOffset: -2
    }
});

const tabIndicatorSx = {
    backgroundColor: THEME_BORDER,
    height: 3,
    borderRadius: '3px 3px 0 0',
    transition: 'background 0.2s',
};

const UploadPicturesAndReport = () => {
    const { taskId } = useParams();
    const navigate = useNavigate();

    const classes = useStyles();
    const dispatch = useDispatch();

    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const username = localStorage.getItem('username');
    const [testImages, setTestImages] = useState(false);
    const taskReducer = useSelector((state) => state.taskReducer?.taskList?.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    useEffect(() => {
        const fetchTask = async () => {
            try {
                const response = await getTask(taskId, username);
                setTask(response)
                setInfoSinistre(response?.businessKey)
                setClaimNumber(response?.businessKey)
            } catch (error) {
                console.error(`Error fetching task details: ${error.message}`);
            }
        };
        fetchTask();
    }, [dispatch, taskId, username]);

    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey);
    const [claimNumber, setClaimNumber] = useState(task?.businessKey);
    const [value, setValue] = useState(0);
    const [uid, setUid] = useState('');
    const [refresh, setRefresh] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [imagesLoading, setImagesLoading] = useState(true);

    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);
    const [openPreviewPDF, setOpenPreviewPDF] = useState(false);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (task?.assignee === username) {
            setIsTaskClaimed(false);
        } else {
            setIsTaskClaimed(true);
        }
    }, [task]);

    // Check server for existing before & after pictures
    const refreshPicturesState = React.useCallback(async () => {
        if (!claimNumber) return false;
        try {
            const files = await dispatch(getAllFileForClaim(claimNumber));
            const hasBefore = Array.isArray(files)
                ? files.some((file) => Array.isArray(file?.metadata) && file.metadata.some((m) => m?.value === "PICTURE_BEFORE_REPARATION"))
                : false;
            const hasAfter = Array.isArray(files)
                ? files.some((file) => Array.isArray(file?.metadata) && file.metadata.some((m) => m?.value === "PICTURE_AFTER_REPARATION"))
                : false;
            const hasBoth = Boolean(hasBefore && hasAfter);
            setTestImages(hasBoth);
            return hasBoth;
        } catch (e) {
            return testImages;
        } finally {
            setImagesLoading(false);
        }
    }, [dispatch, claimNumber, testImages]);

    // When claim number becomes available, fetch initial pictures state
    useEffect(() => {
        if (claimNumber) {
            setImagesLoading(true);
            refreshPicturesState();
        }
    }, [claimNumber, refreshPicturesState]);

    // Only requires upload document and images validation
    const validateInputs = () => {
        const validationErrors = [];
        if (!uid) {
            validationErrors.push("Veuillez télécharger le rapport");
        }
        if (!testImages) {
            validationErrors.push("Merci d'ajouter les photos avant et après la réparation.");
        }
        return validationErrors;
    };

    // The validation action for just upload
    const ValidationAction = async () => {
        // Refresh images state from server to avoid stale UI value
        const hasImagesNow = await refreshPicturesState();
        const validationErrors = [];
        if (!uid) {
            validationErrors.push("Veuillez télécharger le rapport");
        }
        if (!hasImagesNow) {
            validationErrors.push("Merci d'ajouter les photos avant et après la réparation.");
        }

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }

        try {
            // console.log("done")
            await dispatch(completeTask(taskId, username, {}));
            navigate('/todo-list', { reload: true });
        } catch (error) {
            console.error(error);
            setErrors(["Erreur lors de la validation. Veuillez réessayer."]);
            setOpenErrorDialog(true);
        }
    }

    const handleUploadClick = () => {
        document.getElementById('fileInput').click();
    };

    const handleFileChange = async (event) => {
        setLoading(true);

        const file = event.target.files[0];
        if (!file) {
            setLoading(false);
            return;
        }

        const validTypes = ['application/pdf', 'image/jpeg', 'image/png'];
        if (!validTypes.includes(file.type)) {
            toast.error("Seuls les fichiers PDF et images (JPEG, PNG) sont acceptés");
            setLoading(false);
            return;
        }

        const fileUrl = URL.createObjectURL(file);
        setPdfUrl(fileUrl);

        const formData = new FormData();
        formData.append('fileUploaded', file);
        formData.set('createdBy', username);
        formData.set('key', 'NUM_SIN');
        formData.set('value', claimNumber);
        try {
            const response = await dispatch(uploadFile(formData));
            const uid = response.uid;
            setUid(uid);

            const metaData = {
                key: 'TYPE_DOCUMENT',
                value: 'INVOICE',
            };
            await dispatch(addMetaDataToFile(uid, metaData));
            setRefresh(!refresh);
        } catch (error) {
            console.error(error);
            toast.error("Une erreur est survenue lors de l'ajout du fichier");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteFile = async () => {
        setPdfUrl(null);
        setUid(null);
        try {
            await dispatch(deleteFileImage(uid));
            setRefresh(!refresh);
        } catch (error) {
            console.error("Error deleting file:", error);
        }
    };

    return (
        <div className={classes.root}>
            <div style={{ display: 'flex' }}>
                <div className={classes.mainContent}>
                    <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed} />

                    <Paper className={classes.paper}>
                        <Tabs
                            value={value}
                            sx={{
                                marginTop: "10px",
                                marginLeft: "10px",
                                variant: "fullWidth",
                                borderBottom: `1px solid ${THEME_ACCENT_BG}`,
                                // MUI Tabs indicator custom style (must use TabIndicatorProps for newer MUI)
                                "& .MuiTabs-indicator": tabIndicatorSx,
                                // Remove default blue focus ring and ripple for the tabs container area
                                '& .Mui-selected': {
                                    color: THEME_MAIN_COLOR + " !important",
                                    background: THEME_ACCENT_BG + " !important"
                                },
                                '& .MuiTab-root:focus': {
                                    outline: `1px solid ${THEME_BORDER} !important`,
                                },
                            }}
                            TabIndicatorProps={{
                                style: {
                                    backgroundColor: THEME_BORDER,
                                    height: 3,
                                    borderRadius: '3px 3px 0 0'
                                }
                            }}
                            onChange={handleChange}
                        >
                            <Tab
                                sx={getTabSx(value === 0)}
                                {...a11yProps(0)}
                                label="Upload Photos"
                            />
                            <Tab
                                sx={getTabSx(value === 1)}
                                {...a11yProps(1)}
                                label="Upload Rapport"
                            />
                        </Tabs>

                        <CustomTabPanel value={value} index={0}>
                            {claimNumber ? (
                                imagesLoading ? (
                                    <div
                                        style={{
                                            padding: 32,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            minHeight: 180,
                                            flexDirection: 'column',
                                            color: '#818181',
                                            background: '#F7F8FA',
                                            borderRadius: 11,
                                            border: '1px solid #ECECEC',
                                        }}
                                    >
                                        <svg
                                            width="40"
                                            height="40"
                                            viewBox="0 0 40 40"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{ marginBottom: 16 }}
                                        >
                                            <circle cx="20" cy="20" r="20" fill="#E9EAEF" />
                                            <path d="M25 23V17H15V23" stroke="#A0A4B8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M18 20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20C16 19.4477 16.4477 19 17 19C17.5523 19 18 19.4477 18 20Z" fill="#A0A4B8" />
                                            <rect x="13" y="14" width="14" height="12" rx="2" stroke="#A0A4B8" strokeWidth="1.5" />
                                        </svg>
                                        <div style={{ fontSize: 16, fontWeight: 500 }}>Chargement...</div>
                                    </div>
                                ) : (
                                    <ImagesTab claimNumber={claimNumber} isTaskClaimed={isTaskClaimed} setTestImages={setTestImages} />
                                )
                            ) : (
                                <div
                                    style={{
                                        padding: 32,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        minHeight: 180,
                                        flexDirection: 'column',
                                        color: '#818181',
                                        background: '#F7F8FA',
                                        borderRadius: 11,
                                        border: '1px solid #ECECEC',
                                    }}
                                >
                                    <svg
                                        width="40"
                                        height="40"
                                        viewBox="0 0 40 40"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{ marginBottom: 16 }}
                                    >
                                        <circle cx="20" cy="20" r="20" fill="#E9EAEF" />
                                        <path d="M25 23V17H15V23" stroke="#A0A4B8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M18 20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20C16 19.4477 16.4477 19 17 19C17.5523 19 18 19.4477 18 20Z" fill="#A0A4B8" />
                                        <rect x="13" y="14" width="14" height="12" rx="2" stroke="#A0A4B8" strokeWidth="1.5" />
                                    </svg>
                                    <div style={{ fontSize: 16, fontWeight: 500 }}>Chargement...</div>
                                </div>
                            )}
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <Paper className={classes.paper1}>
                                <div className={classes.leftSection} style={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}>
                                    {pdfUrl ? (
                                        <>
                                            <div className={classes.uploadRectangle}>
                                                <div className={classes.uploadTextPrimary}>
                                                    Prévisualiser votre Rapport
                                                </div>
                                                {loading ? (
                                                    <TailSpin color="rgba(187, 200, 8, 1)" radius={"10px"} />
                                                ) : (
                                                    <div
                                                        style={{
                                                            position: 'relative',
                                                            width: '100%',
                                                            maxWidth: '800px',
                                                            height: '60vh',
                                                            minHeight: "325px",
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <iframe
                                                            src={pdfUrl}
                                                            width="100%"
                                                            height="100%"
                                                            style={{
                                                                minWidth: "375px",
                                                                minHeight: "325px",
                                                                width: "100%",
                                                                height: "100%",
                                                                pointerEvents: 'none',
                                                                border: "none",
                                                                borderRadius: "8px",
                                                                background: "#fff"
                                                            }}
                                                            title="PDF Viewer"
                                                        />
                                                        <div
                                                            onClick={() => {
                                                                if (pdfUrl) {
                                                                    setOpenPreviewPDF(true);
                                                                }
                                                            }}
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100%',
                                                                height: '100%',
                                                                cursor: 'pointer',
                                                                backgroundColor: 'transparent',
                                                            }}
                                                        ></div>
                                                    </div>
                                                )}
                                            </div>
                                            <button
                                                style={annulerStyle}
                                                onClick={() => {
                                                    handleDeleteFile();
                                                }}
                                            >
                                                Supprimer le fichier
                                            </button>
                                        </>
                                    ) : (
                                        <div className={classes.uploadRectangle} style={{ width: '100%', maxWidth: '900px' }} onClick={handleUploadClick}>
                                            <BsUpload style={{ color: THEME_MAIN_COLOR }} size={40} />
                                            <div className={classes.uploadTextPrimary}>
                                                Ajoutez votre rapport
                                            </div>
                                            <div className={classes.uploadTextSecondary}>
                                                Déposez votre rapport{" "}
                                                <u style={{ color: THEME_MAIN_COLOR }}>parcourir</u> un
                                                fichier <br /> depuis votre ordinateur.
                                            </div>
                                            <input
                                                id="fileInput"
                                                type="file"
                                                accept="image/*,application/pdf"
                                                className={classes.hiddenInput}
                                                disabled={isTaskClaimed}
                                                onInput={handleFileChange}
                                            />
                                        </div>
                                    )}
                                </div>
                            </Paper>
                        </CustomTabPanel>
                    </Paper>
                </div>
                <PreviewButton claimData={infoSinistre} />
            </div>
            <ValidationButton
                handleValidation={() => isTaskClaimed ? null : ValidationAction()}
            />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
            <PreviewPDF pdfUrl={pdfUrl} open={openPreviewPDF} onClose={() => setOpenPreviewPDF(false)} />
        </div>
    );
};

export default UploadPicturesAndReport;
